import Button from '__components/Button';
import useModal from '__components/Modals/useModal';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { generateCSV } from 'pages/SmartConnectors/SmartConnector/helpers';
import { CreateActivityModal } from './CreateActivityModal';
import type { LoggedActivityEntry } from '@kizen/api/activities';

type CreateActivityButtonProps = {
  fileInputRef: React.RefObject<HTMLInputElement>;
};

// format: activity-sample-YYYY-MM-DD_hh-mm-ss.csv
const getCSVFileName = () =>
  `activity-sample-${new Date()
    .toLocaleDateString('en')
    .split('/')
    .join(
      '-'
    )}_${new Date().toLocaleTimeString('en', { hour12: false }).split(':').join('-')}.csv`;

export const CreateActivityButton: FC<CreateActivityButtonProps> = ({
  fileInputRef,
}) => {
  const { t } = useTranslation();

  const [modalProps, { onClick }] = useModal({
    handleSubmit: (loggedActivities: LoggedActivityEntry[]) => {
      if (fileInputRef.current) {
        const csvText = generateCSV([
          ['_logged_activity_id'],
          ...loggedActivities.map(({ id }) => [id]),
        ]);

        const dataTransfer = new DataTransfer();
        const file = new File(
          [new Blob([csvText], { type: 'text/csv;charset=utf-8' })],
          getCSVFileName()
        );
        dataTransfer.items.add(file);

        fileInputRef.current.focus();
        fileInputRef.current.files = dataTransfer.files;
        fileInputRef.current.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        fileInputRef.current.blur();
      }
    },
  });

  return (
    <>
      <Button variant="outline" color="blue" onClick={onClick}>
        {t('Generate Sample File')}
      </Button>
      {modalProps.show ? <CreateActivityModal {...modalProps} /> : null}
    </>
  );
};
